import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static values = {
    site: String,
    sessionUrl: String,
  };

  static targets = ["error", "errorMessage"];

  connect() {
    Chargebee.init({ site: this.siteValue });
    this.cbInstance = Chargebee.getInstance();
  }

  async open(event) {
    event.preventDefault();

    this.hideError();

    const response = await post(this.sessionUrlValue, { responseKind: "json" });
    if (!response.ok) {
      const body = await response.json;
      this.showError(
        body?.error || `Failed to create Chargebee portal session: ${response.statusCode}`
      );
      return;
    }
    const portalSession = await response.json;

    this.cbInstance.setPortalSession(() => Promise.resolve(portalSession));
    this.cbInstance.createChargebeePortal().open();
  }

  showError(message) {
    this.errorMessageTarget.textContent = message;
    this.errorTarget.classList.remove("hidden");
  }

  hideError() {
    this.errorTarget.classList.add("hidden");
    this.errorMessageTarget.textContent = "";
  }
}
